import styled, { css } from 'styled-components';

import { Container as BaseContainer } from '../SupportBlock.styled';

export const Container = styled(BaseContainer)`
    ${({ theme }) => css`
        font-size: 1.125rem;
        line-height: 1.4;
        display: flex;
        flex-direction: column;
        align-items: center;

        @media ${theme.breakpoints.medium.media} {
            flex-direction: row;
            align-items: stretch;
        }

        @media ${theme.breakpoints.large.media} {
            padding-bottom: 2rem;
            font-size: 1.25rem;
            flex-direction: column;
            align-items: center;
        }
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        flex: 0 0 auto;
        height: 6rem;
        width: 60%;

        @media ${theme.breakpoints.medium.media} {
            padding-right: 1.5rem;
            height: auto;
            width: 40%;
        }

        @media ${theme.breakpoints.large.media} {
            padding-bottom: 1rem;
            height: 9rem;
            width: 50%;
        }
    `}
`;

export const Content = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;

        @media ${theme.breakpoints.medium.media} {
            text-align: left;
            align-items: flex-start;
        }

        @media ${theme.breakpoints.large.media} {
            text-align: center;
            align-items: center;
        }
    `}
`;
